import React from "react";
import "./Gradient.scss";

interface propTypes {
  children: React.ReactNode;
}

const Gradient = (props: propTypes): JSX.Element => {
  return (
    <>
      <div className="gradient-text font-weight-8 text-title-1">
        {props.children}
      </div>
    </>
  );
};

export default Gradient;
